import { Routes, Route } from 'react-router-dom'
import { ApiTable } from '../../../components/table/ApiTable'
import axios from 'axios'
import Toolbar from '../Toolbar/Toolbar'
import { useSearchText } from '../useSearchText'
import { useState } from 'react'
import { Button, IconButton, Menu, MenuItem } from '@mui/material'
import MoreHorizIcon from '@mui/icons-material/MoreHoriz'
import { AddReview } from './AddReview'
import { EditReview } from './EditReview'

const listReviews = async () => {
  const url = process.env.REACT_APP_WAKACJE_API_URL + `/v1.1/admin/companies/reviews?limit=1000&after=0`
  const res = await axios.get(url)

  const result = {
    ...res.data,
    data: res.data.data
  }

  return result
}

const ActionsMenu = ({ onEdit }) => {
  const [anchorEl, setAnchorEl] = useState(null)

  const handleOpen = event => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const handleEdit = () => {
    handleClose()
    onEdit()
  }

  return (
    <>
      <IconButton onClick={handleOpen}>
        <MoreHorizIcon />
      </IconButton>
      <Menu
        style={{ width: '200px' }}
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        <MenuItem onClick={handleEdit}>Edytuj</MenuItem>
      </Menu>
    </>
  )
}

const SuperAdminReviewsTable = ({ queryParams, onEdit }) => {
  const columns = [
    {
      header: 'Firma',
      field: 'company_id',
      cell: (row: any) => <div>{row.company_id}</div>
    },
    {
      header: 'Użytkownik',
      field: 'user',
      cell: (row: any) => <div>{row.user}</div>
    },
    {
      header: 'Ocena',
      field: 'rating',
      cell: (row: any) => <div>{row.rating}/5</div>
    },
    {
      header: 'Komentarz',
      field: 'comment',
      cell: (row: any) => <div>{row.comment}</div>
    },
    {
      header: 'Obóz',
      field: 'camp_name',
      cell: (row: any) => <div>{row.camp_name}</div>
    },
    // {
    //   header: 'Data utworzenia',
    //   field: 'created_at',
    //   cell: (row: any) => (
    //     <div className='leading-none font-bold text-xs'>
    //       <p className='whitespace-nowrap'>
    //         <FormattedDate value={row.created_at} />
    //       </p>
    //     </div>
    //   )
    // },
    {
      header: '',
      field: 'actions',
      cell: row => <ActionsMenu onEdit={() => onEdit(row)} />
    }
  ]

  return (
    <ApiTable
      columns={columns}
      listApi={listReviews}
      showExpandColumn
      queryParams={queryParams}
    />
  )
}

export const SuperAdminReviewsList = () => {
  const { setSearchTextDebounced, queryParams } = useSearchText()
  const mergedQueryParams = { ...queryParams }

  const [isAddReviewModalOpen, setIsAddReviewModalOpen] = useState(false)
  const [isEditReviewModalOpen, setIsEditReviewModalOpen] = useState(false)
  const [selectedReview, setSelectedReview] = useState(null)

  const handleAddReviewOpenModal = () => setIsAddReviewModalOpen(true)
  const handleAddReviewCloseModal = () => setIsAddReviewModalOpen(false)

  const handleEditReviewOpenModal = review => {
    setSelectedReview(review)
    setIsEditReviewModalOpen(true)
  }

  const handleEditReviewCloseModal = () => {
    setSelectedReview(null)
    setIsEditReviewModalOpen(false)
  }

  return (
    <>
      <Toolbar
        setSearchTextDebounced={setSearchTextDebounced}
        api={listReviews}
        queryParams={mergedQueryParams}
      >
        <Button
          variant='outlined'
          sx={{
            borderWidth: '0',
            height: '28px',
            ':hover': { borderWidth: '0' }
          }}
          onClick={handleAddReviewOpenModal}
        >
          Dodaj recenzję
        </Button>
      </Toolbar>

      <AddReview
        open={isAddReviewModalOpen}
        onClose={handleAddReviewCloseModal}
      />

      <EditReview
        open={isEditReviewModalOpen}
        reviewData={selectedReview}
        onClose={handleEditReviewCloseModal}
      />

      <Routes>
        <Route
          index
          element={
            <SuperAdminReviewsTable
              queryParams={mergedQueryParams}
              onEdit={handleEditReviewOpenModal}
            />
          }
        />
      </Routes>
    </>
  )
} 